import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { ResetPasswordContainer } from '../../modules/auth/containers/ResetPasswordContainer';

export const ResetPasswordView = (): ReactElement => (
  <AuthContainer>
    <ResetPasswordContainer />
  </AuthContainer>
);
